<div class="panel-dropdown-wrapper" (clickOutside)="closeWhenClickedOutside($event)">
    <div class="panel-dropdown-trigger" (click)="toggleProfileMenu()">
        <img src="/assets/temp-acc.png" alt="user-avatar" class="user-avatar">
    </div>

    <div class="panel-dropdown mpro-box" *ngIf="isProfileMenuOpened">
        <mpro-user-info [row]="true" [userData]="authService.currentUserValue.data"></mpro-user-info>
        <ng-container *ngIf="!(authService.permissions$ | async)?.isFreemium">
            <div *ngFor="let nav of navService.navigation" class="panel-dropdown-item" [routerLink]="nav.route">
                <svg-icon [key]="nav.icon"></svg-icon>
                <span>{{ nav.title }}</span>
            </div>
        </ng-container>
        <div class="panel-dropdown-item" (click)="authService.logout()">
            <svg-icon key="logout"></svg-icon>
            <span>Logout of World Data Pro</span>
        </div>
    </div>
</div>
